import { indexEquals, isItemGroup } from './utils';
export default function moveHighlight({ startIndex, expandedIndex, getNext, isExpandable, planeOf, isInRestrictedView, }) {
    const tryMove = (currentIndex) => {
        var _a;
        const next = getNext(currentIndex);
        if (!next) {
            return null;
        }
        // A disabled expandable group can't be opened, so its children are never rendered — skip them.
        if (((_a = next.parent) === null || _a === void 0 ? void 0 : _a.disabled) && isExpandable(next.parent)) {
            return tryMove(next.index);
        }
        // only an expandable group's header is highlightable; a flat group's is skipped
        if (isItemGroup(next.item) && !isExpandable(next.item)) {
            return tryMove(next.index);
        }
        // confine to the current plane; in fully-flat mode every index is top plane so this never clamps
        if (!isInRestrictedView && !isSamePlane(planeOf(startIndex), planeOf(next.index))) {
            return tryMove(next.index);
        }
        // in restricted view, admit the top plane plus the currently-expanded group's plane
        if (isInRestrictedView &&
            !isSamePlane(planeOf(next.index), []) &&
            !isSamePlane(planeOf(next.index), expandedIndex)) {
            return tryMove(next.index);
        }
        return next.index;
    };
    return tryMove(startIndex);
}
function isSamePlane(left, right) {
    return indexEquals(left, right);
}
//# sourceMappingURL=move-highlight.js.map